export enum GeneratedMockupApprovalStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
  CHANGES_REQUESTED = "changes_requested",
}

export type GeneratedMockupSource = "manual" | "generated";

export interface GeneratedMockup {
  id: number;
  source: GeneratedMockupSource;
  customer_id: number;
  store_id: number | null;
  product_id: number;
  variant_sku?: string | null;
  psd_template_id: number;
  reference_id: string | null;
  mockup_url: string;
  approval_status?: GeneratedMockupApprovalStatus;
  rejection_reason?: string | null;
  rejection_evidence_url?: string | null;
  created_at: string;
  updated_at?: string;
  generated_by_admin_id: number | null;
  generated_by_user_id: number | null;
  approved_by_admin_id?: number | null;
  approved_by_admin_name?: string | null;
  approved_by_user_id?: number | null;
  approved_by_user_name?: string | null;
  approved_on_behalf_by_admin_id?: number | null;
  approved_on_behalf_by_admin_name?: string | null;
  approved_on_behalf_reason?: string | null;
  approved_on_behalf_evidence_url?: string | null;
  rejected_by_admin_id?: number | null;
  rejected_by_admin_name?: string | null;
  rejected_by_user_id?: number | null;
  rejected_by_user_name?: string | null;
  rejected_at?: string | null;
  iteration_no?: number | null;
  is_rejected?: boolean;
  is_fully_approved?: boolean;
  can_delete?: boolean;
}

export interface GeneratedMockupActionState {
  id: number;
  source?: GeneratedMockupSource;
  mockup_url?: string;
  approval_status?: GeneratedMockupApprovalStatus | string | null;
  rejection_reason?: string | null;
  rejection_evidence_url?: string | null;
  approved_by_admin_id?: number | null;
  approved_by_admin_name?: string | null;
  approved_by_user_id?: number | null;
  approved_by_user_name?: string | null;
  approved_on_behalf_by_admin_id?: number | null;
  approved_on_behalf_by_admin_name?: string | null;
  approved_on_behalf_reason?: string | null;
  approved_on_behalf_evidence_url?: string | null;
  rejected_by_admin_id?: number | null;
  rejected_by_admin_name?: string | null;
  rejected_by_user_id?: number | null;
  rejected_by_user_name?: string | null;
  rejected_at?: string | null;
  iteration_no?: number | null;
  is_rejected?: boolean;
  is_fully_approved?: boolean;
  can_delete?: boolean;
  updated_at?: string;
}

export interface GeneratedMockupStatus {
  id: number;
  variant_sku?: string | null;
  source: GeneratedMockupSource;
  psd_template_id?: number;
  reference_id: string | null;
  mockup_url: string;
  approval_status?: GeneratedMockupApprovalStatus;
  rejection_reason?: string | null;
  rejection_evidence_url?: string | null;
  created_at: string;
  updated_at?: string;
  approved_by_admin_id?: number | null;
  approved_by_admin_name?: string | null;
  approved_by_user_id?: number | null;
  approved_by_user_name?: string | null;
  approved_on_behalf_by_admin_id?: number | null;
  approved_on_behalf_by_admin_name?: string | null;
  approved_on_behalf_reason?: string | null;
  approved_on_behalf_evidence_url?: string | null;
  rejected_by_admin_id?: number | null;
  rejected_by_admin_name?: string | null;
  rejected_by_user_id?: number | null;
  rejected_by_user_name?: string | null;
  rejected_at?: string | null;
  iteration_no?: number | null;
  is_rejected?: boolean;
  is_fully_approved?: boolean;
  can_delete?: boolean;
  show_on_storefront?: number | boolean | null;
}

export interface GeneratedMockupComment {
  id: number;
  generated_mockup_id: number;
  comment: string;
  admin_id: number | null;
  user_id: number | null;
  created_at: string;
  updated_at: string;
}
